'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'OrgRestService',
    function ($modal, OrgRestService) {

        return {
            select: select,
            edit: edit,
            create: create,
            api: OrgRestService
        };

        function select(org, filters) {
            return $modal.open({
                template: require('../view/org-modal-select.html'),
                controller: 'OrgModalSelectController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: false,
                resolve: {
                    org: function () {
                        return org != null ? org : {};
                    },
                    orgFilters: function () {
                        return Array.isArray(filters) ? filters : [];
                    }
                }
            });
        }

        function create() {
            return $modal.open({
                template: require('../view/org-modal-create.html'),
                controller: 'OrgModalCreateController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: false,
                resolve: {
                    org: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/org-modal-create.html'),
                controller: 'OrgModalCreateController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: false,
                resolve: {
                    org: function () {
                        return item;
                    }
                }
            });
        }

    }];